import { render } from "./view.vue?vue&type=template&id=84821df2&ts=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"

import "./view.vue?vue&type=style&index=0&id=84821df2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Notifications/view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "84821df2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('84821df2', __exports__)) {
    api.reload('84821df2', __exports__)
  }
  
  module.hot.accept("./view.vue?vue&type=template&id=84821df2&ts=true", () => {
    api.rerender('84821df2', render)
  })

}


export default __exports__